import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

export class DashboardServiceHandler extends BaseService {
  isAuditButtonClicked: boolean;
  forAuditSearchList: boolean;

  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, '');
  }

  public init(modelNameList: string[]): Observable<Object> {
    return;
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean): Observable<Object> {
    return;
  }
  public process(id: any, modelNameList: string[]): Observable<Object> {
    return;
  }
  public find(executeSearch?: boolean, searchCriteriaData?: any): Observable<Object> {
    return;
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return null;
  }

  getNewBusinessData(fieldnames, frequency, calculationyears?): Observable<Object> {
    const dateStr = this.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);

    let body: any = {
      fieldNames: fieldnames,
      frequency: frequency,
    };

    if (Array.isArray(calculationyears) && calculationyears.length > 0) {
      body.calculationYears = calculationyears;
    } else {
      body.calculationYears = [String(year), String(year - 1)];
    }
    return this.httpPost('api/datamart/getNewBusinessData', body);
  }

  getPerformanceData(fieldnames, frequency, calculationyears?): Observable<Object> {
    const dateStr = this.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);

    let body: any = {
      fieldNames: fieldnames,
      frequency: frequency,
    };

    if (Array.isArray(calculationyears) && calculationyears.length > 0) {
      body.calculationYears = calculationyears;
    } else {
      body.calculationYears = [String(year), String(year - 1)];
    }

    return this.httpPost('api/datamart/getPerformanceDashboardData', body);
  }

  getIncomeExpenseData(fieldnames, frequency, calculationyears?) {
    const dateStr = this.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);

    let body: any = {
      fieldNames: fieldnames,
      frequency: frequency,
    };

    if (Array.isArray(calculationyears) && calculationyears.length > 0) {
      body.calculationYears = calculationyears;
    } else {
      body.calculationYears = [String(year), String(year - 1)];
    }
    return this.httpPost('api/datamart/getIncomeExpenseData', body);
  }

  getAgentPerformanceData(order): Observable<Object> {
    let body = {
      order: order,
      NumberofAgents: 5,
    };
    return this.httpPost('api/datamart/getAgentPerformanceData', body);
  }

  onDateRangeChange(event: any) {
    const value = event.target.value;
    if (value) {
      const [startDateStr, endDateStr] = value.split(' - ');
      const startYear = new Date(startDateStr).getFullYear();
      const endYear = new Date(endDateStr).getFullYear();

      const years: string[] = [];
      for (let y = startYear; y <= endYear; y++) {
        years.push(String(y));
      }
      return years;
    }
  }

  public addRoundedBars(Chart) {
    Chart.elements.Rectangle.prototype.draw = function () {
      const ctx = this._chart.ctx;
      const vm = this._view;
      const chart = this._chart;
      const borderRadius = 20;

      let left, right, top, bottom;
      const horizontal = vm.horizontal;

      if (!horizontal) {
        left = vm.x - vm.width / 2;
        right = vm.x + vm.width / 2;
        top = Math.min(vm.y, vm.base);
        bottom = Math.max(vm.y, vm.base);
      } else {
        left = Math.min(vm.x, vm.base);
        right = Math.max(vm.x, vm.base);
        top = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
      }

      const xStacked =
        chart.options.scales?.xAxes?.[0]?.stacked ?? chart.options.scales?.scales?.xAxes?.[0]?.stacked;
      const yStacked =
        chart.options.scales?.yAxes?.[0]?.stacked ?? chart.options.scales?.scales?.yAxes?.[0]?.stacked;

      const isStacked = horizontal ? xStacked : yStacked;

      const applyRadius = !isStacked;
      const radiusX = applyRadius ? Math.min(borderRadius, (right - left) / 2) : 0;
      const radiusY = applyRadius ? Math.min(borderRadius, (bottom - top) / 2) : 0;

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = vm.borderWidth;

      if (!horizontal) {
        if (vm.y < vm.base) {
          ctx.moveTo(left, bottom);
          ctx.lineTo(left, top + radiusY);
          ctx.quadraticCurveTo(left, top, left + radiusX, top);
          ctx.lineTo(right - radiusX, top);
          ctx.quadraticCurveTo(right, top, right, top + radiusY);
          ctx.lineTo(right, bottom);
        } else {
          ctx.moveTo(left, top);
          ctx.lineTo(left, bottom - radiusY);
          ctx.quadraticCurveTo(left, bottom, left + radiusX, bottom);
          ctx.lineTo(right - radiusX, bottom);
          ctx.quadraticCurveTo(right, bottom, right, bottom - radiusY);
          ctx.lineTo(right, top);
        }
      } else {
        if (vm.x > vm.base) {
          ctx.moveTo(left, top);
          ctx.lineTo(right - radiusX, top);
          ctx.quadraticCurveTo(right, top, right, top + radiusY);
          ctx.lineTo(right, bottom - radiusY);
          ctx.quadraticCurveTo(right, bottom, right - radiusX, bottom);
          ctx.lineTo(left, bottom);
          ctx.lineTo(left, top);
        } else {
          ctx.moveTo(right, top);
          ctx.lineTo(left + radiusX, top);
          ctx.quadraticCurveTo(left, top, left, top + radiusY);
          ctx.lineTo(left, bottom - radiusY);
          ctx.quadraticCurveTo(left, bottom, left + radiusX, bottom);
          ctx.lineTo(right, bottom);
          ctx.lineTo(right, top);
        }
      }

      ctx.closePath();
      ctx.fill();

      if (vm.borderWidth) {
        ctx.stroke();
      }
    };
  }

  public regionColors() {
    return [
      '#1E88E5', // Medium Blue (like TD Ameritrade line)
      '#F9A825', // Amber/Golden Yellow (like SCHW line)
      '#43A047', // Medium Teal Green (similar to IBKR line)
      '#FB8C00', // Bright Orange (similar to ETFC line)

      // '#0D47A1', // Dark Blue
      // '#1565C0', // Medium Blue
      // '#1976D2', // Standard Blue
      // '#42A5F5', // Sky Blue
      // '#90CAF9', // Soft Blue

      // '#6A1B9A', // Deep Purple
      // '#E1BEE7', // Light Lavender
      // '#BA68C8', // Medium Purple
      // '#8E24AA', // Classic Purple

      '#EF6C00', // Strong Amber
      '#FFB74D', // Light Amber
      '#FF9800', // Warm Orange
      '#F57C00', // Mid Orange

      '#98BDF9', // Light Blue
      '#3E82F7', // Primary Blue
      '#C2D9FB', // Very Light Blue
      '#669DF6', // Medium Blue

      '#5D4037', // Deep Brown
      '#8D6E63', // Soft Mocha
      '#BCAAA4', // Light Mocha
      '#D7CCC8', // Taupe
    ];
  }

  public productColors() {
    return [
      '#1E88E5', // blue
      '#d62728', // red
      '#2ca02c', // green
      '#ff7f0e', // orange
      '#9467bd', // purple
      '#8c564b', // brown
      '#e377c2', // pink
      '#7f7f7f', // gray
      '#bcbd22', // olive
      '#17becf', // cyan
    ];
  }

  // public extractApiData(res: any): any {
  //   try {
  //     const resData = JSON.parse(JSON.stringify(res));
  //     return resData?.data?.data?.[0] || {};
  //   } catch {
  //     console.error('Failed to parse response data');
  //     return {};
  //   }
  // }

  // Extract data
  public extractApiData(responseData: any): any {
    try {
      const parsed = JSON.parse(JSON.stringify(responseData));
      return parsed?.data?.data?.[0] || {};
    } catch (error) {
      console.error('Data parsing error', error);
      return null;
    }
  }

  public getChannelsToProcess(
    selectedChannels: string | string[] | undefined,
    availableChannels: string[]
  ): string[] {
    if (
      !selectedChannels ||
      selectedChannels.length === 0 ||
      (Array.isArray(selectedChannels) && selectedChannels.includes('All'))
    ) {
      return availableChannels;
    }
    return Array.isArray(selectedChannels) ? selectedChannels : [selectedChannels];
  }

  public hasValidData(rawData: any) {
    return rawData && typeof rawData === 'object' && Object.keys(rawData).length > 0;
  }

  public buildCommonChartOptions({
    tooltipMeta,
    chartType,
  }: {
    tooltipMeta?: any;
    chartType: 'region' | 'channel';
  }) {
    if (chartType === 'region') {
      return {
        // Region chart options
        responsive: true,
        maintainAspectRatio: false,
        hover: { mode: 'nearest', intersect: true },
        layout: { padding: { left: 40, right: 30 } },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: { display: false, autoSkip: false, callback: (value) => value.split('-')[0] },
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: { callback: (value) => value.toLocaleString() },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
          align: 'center',
          labels: {
            boxWidth: 12,
            fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
            padding: this.settingService.isMobileViewRendered() ? 30 : 30,
          },
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          callbacks: {
            title: (tooltipItems) => {
              const idx = tooltipItems[0].index;
              const meta = tooltipMeta[idx];
              return `${meta.channel} - ${meta.period}, ${meta.year}`;
            },
          },
        },
      };
    } else if (chartType === 'channel') {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: { label: (ctx) => `${ctx.label}: ${ctx.parsed.toLocaleString()}` },
          },
        },
        legend: { display: false, position: 'bottom' },
      };
    }
  }
}
